import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardMainScreenService {

  filter: Subject<any> = new Subject<any>()

  reloadSprintsList: Subject<boolean> = new Subject<boolean>()
  reloadSprints: Subject<boolean> = new Subject<boolean>()
  closeOverlayTask: Subject<boolean> = new Subject<boolean>()
  openSprintForm: Subject<any> = new Subject<any>()
  openTaskForm: Subject<any> = new Subject<any>()
  openTaskModalView: Subject<any> = new Subject<any>()
  openCalendar: Subject<any> = new Subject<any>()
  realoadSubtasks: Subject<any> = new Subject<any>()
  realoadTasks: Subject<any> = new Subject<any>()
  realoadEvents: Subject<any> = new Subject<any>()
  openEventView: Subject<any> = new Subject<any>()
  openRequestView: Subject<any> = new Subject<any>()
  openTaskView: Subject<any> = new Subject<any>()
  openRelatedTicketView: Subject<any> = new Subject<any>()
  reloadCard: Subject<number> = new Subject<number>()
  reloadCard2: Subject<number> = new Subject<number>()
  trackingRunning: Subject<any> = new Subject<any>()
  trackingRunningTopBar: Subject<boolean> = new Subject<boolean>()

  constructor() { }
}
